import { render, staticRenderFns } from "./InterviewScoreCard.vue?vue&type=template&id=31f9d13b&scoped=true&"
import script from "./InterviewScoreCard.vue?vue&type=script&lang=js&"
export * from "./InterviewScoreCard.vue?vue&type=script&lang=js&"
import style0 from "./InterviewScoreCard.vue?vue&type=style&index=0&id=31f9d13b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f9d13b",
  null
  
)

export default component.exports